<template>
	<div class="flex flex-col min-h-screen home">
		<SiteHeader />

		<div class="content">
			<div class="min-h-screen section-mainbanner">
				<div class="container flex items-center min-h-screen px-4 pt-40 pb-16 text-center text-white lg:text-left font-montserrat">
					<div class="flex flex-wrap items-center w-full">
						<div class="w-full px-4 mb-12 text-center lg:w-7/12 lg:mb-0">
							<h2 class="text-4xl font-semibold uppercase leading-tighter lg:text-6xl">Efficient, Reliable, and Safe Bus Transport Provider</h2>
						</div>
						<div class="w-full px-4 py-8 text-white lg:py-12 lg:px-8 bg-siteRed lg:w-5/12">
							<h2 class="mb-6 text-xl font-semibold leading-none text-center uppercase font-montserrat">Message Sending Successful!</h2>
							<p class="mb-12 text-center">
								Thank you for your kind interest in L8 Infrastructure Solutions Pte Ltd! We will get back to you as soon as possible.
							</p>
							<div class="flex justify-center">
								<a href="/">
									<div class="px-6 py-3 font-semibold text-white duration-200 bg-black rounded-lg cursor-pointer hover:bg-gray-800">
										Back to Homepage
									</div>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<SiteFooter />
	</div>
</template>

<script>
// @ is an alias to /src
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
	name: 'Thank You',
	components: {
		SiteHeader,
		SiteFooter,
	},
}
</script>

<style scoped lang="scss">
	[class*="section-"] {
		@apply bg-center bg-no-repeat bg-cover;
	}

	.section-mainbanner {
		background-image: url('/mainbanner-bg01.jpg');
	}
</style>
